<template>
  <header class="header">
    <!-- header profile -->
    <div class="profile">
      <div class="title">{{ name }}</div>
      <typing-animation v-if="!noTypingAnimation" :arr="arr" />
      <div class="subtitle" v-else>{{ arr }}</div>
    </div>

    <!-- menu btn -->
    <a
      v-if="!noSidebar"
      href="#"
      class="menu-btn"
      @click="navFunction.sidebarToggle(true)"
      ><span></span
    ></a>

    <!-- menu -->
    <div class="top-menu">
      <ul>
        <li
          :class="navFunction.activeNav(menu.href)"
          v-for="menu in menus"
          :key="menu.name"
        >
          <a
            :href="`#` + menu.href"
            @click="navFunction.activeSection(menu.href)"
          >
<!--            <b-icon :icon="menu.icon"></b-icon>-->
            <i :class="menu.icon" />
            <span class="link">{{ menu.name }}</span>
          </a>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import TypingAnimation from "@/components/typingAnimation";
import { navFunction } from "@/navFunction";
export default {
  name: `Header`,
  data() {
    return {
      navFunction
    };
  },
  props: {
    noSidebar: { type: Boolean },
    noTypingAnimation: { type: Boolean },
    arr: { type: Array },
    name: {
      type: String,
      default: "Chunhakrai Buncherdjaruwong"
    },
    menus: {
      type: [Object, Array],
      default: function() {
        return [
          { name: "About", href: "about", icon: "fa fa-user" },
          { name: "Resume", href: "resume", icon: "fa fa-id-card-o" },
          // { name: "Works", href: "works", icon: "icon ion-paintbrush" },
          // { name: "Blog", href: "blog", icon: "icon ion-chatbox-working" },
          // { name: "Contact", href: "contacts", icon: "icon ion-at" }
        ];
      }
    }
  },
  components: { TypingAnimation }
};
</script>
